import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <button
          onClick={() => navigate(-1)}
          className="mb-6 flex items-center text-red-600 hover:text-red-700 transition-colors duration-200"
        >
          <FaArrowLeft className="mr-2" />
          <span>Nazad</span>
        </button>

        <h1 className="text-3xl font-bold text-gray-900 mb-8">Uslovi Korišćenja</h1>
        
        <div className="bg-white rounded-lg shadow-sm p-8 space-y-6">
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Opšte Odredbe</h2>
            <p className="text-gray-600">
              Korišćenjem Zar Mance B2B Portala prihvatate ove uslove korišćenja. 
              Portal je namenjen isključivo pravnim licima za veleprodajne narudžbine.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Registracija i Nalozi</h2>
            <p className="text-gray-600">
              Za korišćenje portala neophodno je:
            </p>
            <ul className="list-disc list-inside text-gray-600 mt-2">
              <li>Posedovanje validnog PIB-a</li>
              <li>Tačni podaci o firmi</li>
              <li>Prihvatanje uslova korišćenja</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Naručivanje</h2>
            <p className="text-gray-600">
              Narudžbine se primaju isključivo preko portala. Minimalna količina za 
              naručivanje i drugi uslovi definisani su za svaki proizvod posebno.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Cene i Plaćanje</h2>
            <p className="text-gray-600">
              Sve cene su izražene bez PDV-a. Zadržavamo pravo promene cena. 
              Uslovi plaćanja se definišu prilikom registracije korisnika.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Isporuka</h2>
            <p className="text-gray-600">
              Rokovi isporuke i uslovi dostave definišu se prilikom potvrde porudžbine. 
              Obavezna je provera robe prilikom prijema.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Reklamacije</h2>
            <p className="text-gray-600">
              Reklamacije se primaju u roku od 24 sata od prijema robe. 
              Sve reklamacije moraju biti dokumentovane fotografijama.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms; 